import { render } from "./App.vue?vue&type=template&id=0fa715ca&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0fa715ca&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2369827012/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa715ca"]])

export default __exports__